export const objectPlanToArrayPlan = objectPlan => {
  if (!objectPlan) {
    return [];
  }

  return Object.keys(objectPlan).map(month => {
    return {
      month: month,
      amount: objectPlan[month],
    };
  }).sort((month1, month2) => {
    if (month1.month === month2.month) {
      return 0;
    }

    return month1.month < month2.month ? -1 : 1;
  });
};

export const arrayPlanToObjectPlan = arrayPlan => {
  const objectPlan = {};

  for (const arrayPlanMonth of arrayPlan) {
    objectPlan[arrayPlanMonth.month] = arrayPlanMonth.amount;
  }

  return objectPlan;
};

export const thereAreEmptyMonths = arrayPlan => !!arrayPlan.find(m => !m.month);

export const getPlanTotal = arrayPlan => (arrayPlan || []).reduce((tot, m) => tot + m.amount, 0);
